// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"d62f5a5e","412":"71716d1b"}[chunkId] + ".chunk.css";
};